import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cardWithName: {
      budget: {
        description: 'Virtual Card •••• {pan}',
        name: '{cardAlias}',
      },
      physical: {
        description: 'Physical Card •••• {pan}',
        name: '{cardAlias}',
      },
      virtual: {
        description: 'Virtual Card •••• {pan}',
        name: '{cardAlias}',
      },
    },
    cardWithoutName: {
      budget: {
        description: '•••• {pan}',
        name: 'Virtual budget card',
      },
      physical: {
        description: '•••• {pan}',
        name: 'Physical Card',
      },
      virtual: {
        description: '•••• {pan}',
        name: 'Virtual Card',
      },
    },
    limitsDescription: '{amount} of {maxAmount}',
    paymentLimit: 'Payment limits',
    virtualCard: 'Virtual Card',
  },
  fr: {
    cardWithName: {
      budget: {
        description: 'Carte Virtuelle •••• {pan}',
        name: '{cardAlias}',
      },
      physical: {
        description: 'Carte Physique •••• {pan}',
        name: '{cardAlias}',
      },
      virtual: {
        description: 'Carte Virtuelle •••• {pan}',
        name: '{cardAlias}',
      },
    },
    cardWithoutName: {
      budget: {
        description: '•••• {pan}',
        name: 'Carte virtuelle à budget',
      },
      physical: {
        description: '•••• {pan}',
        name: 'Carte Physique',
      },
      virtual: {
        description: '•••• {pan}',
        name: 'Carte Virtuelle',
      },
    },
    limitsDescription: '{amount} sur {maxAmount}',
    paymentLimit: 'Plafond de paiement',
    virtualCard: 'Carte Virtuelle',
  },
} as const);

export default locales;
